import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import { Menu } from 'util/ui'
import { START_OF_REPORTS } from 'ducks/reports/constants'
import {
  selectReportsMinStartDate,
  selectTimezoneSource,
  selectTimezoneWithOffsetDisplay,
} from 'ducks/reports/controls/selectors'
import { selectMaxReportingDays } from 'ducks/billing/selectors/features'
import BusinessHoursControl from '../BusinessHoursControl'
import DateControl from '../DateControl'
import ReportingPeriodDropdown from './ReportingPeriodDropdown'
import { shouldShowReportingPeriodDropdown } from './reportingPeriod'
import styles from './styles.less'

export default function ControlBar({ prerenderDatePicker }) {
  const source = useSelector(selectTimezoneSource)
  const timezone = useSelector(selectTimezoneWithOffsetDisplay)
  const maxReportingDays = useSelector(selectMaxReportingDays)
  const minStartDate = useSelector(selectReportsMinStartDate)
  const limitToMinStart = shouldShowReportingPeriodDropdown(
    minStartDate,
    maxReportingDays
  )

  const tooltipTitle = useMemo(
    () => {
      switch (source) {
        case 'ACCOUNT':
          return 'Account timezone used'
        case 'BUSINESS_HOURS':
          return 'Business hours timezone used'
        case 'BROWSER':
          return 'Browser timezone used'
        default:
          return 'Unknown timezone used'
      }
    },
    [source]
  )

  return (
    <Menu fixed="top" className={styles.ControlBar}>
      <Menu.Menu position="left">
        <Menu.Item fitted>
          <BusinessHoursControl />
        </Menu.Item>
      </Menu.Menu>
      <Menu.Menu position="left">
        <Menu.Item>
          <Tooltip title={tooltipTitle}>
            <i>Timezone Used: {timezone}</i>
          </Tooltip>
        </Menu.Item>
      </Menu.Menu>
      <Menu.Menu position="right">
        <Menu.Item fitted>
          {limitToMinStart ? (
            <ReportingPeriodDropdown earliestStartDate={minStartDate} />
          ) : (
            <DateControl
              prerender={prerenderDatePicker}
              earliestStartDate={minStartDate || START_OF_REPORTS}
              coerceToEarliestStartDate={!!minStartDate}
              presetMinStartDate={minStartDate}
              minDays={maxReportingDays}
            />
          )}
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}
